module.exports = __webpack_public_path__ + "img/full2-min.61058537.png";